// import { Formik } from 'formik';
import AntDesign from '@expo/vector-icons/AntDesign';
import { yupResolver } from '@hookform/resolvers/yup';
import { useController, useForm } from 'react-hook-form';
// import { t } from 'i18next';
import { isEmpty } from 'lodash';
import React from 'react';
import { StyleSheet } from 'react-native';
// import { Assets } from 'src/assets';
// import { useServiceQuery } from 'src/common/hooks';

import { formatDate } from 'src/common/utils/DateHelper';

import {
  CardContainer,
  // ButtonInput,
  Container,
  IconButton,
  PrimaryButton,
  RegularText,
  Row,
  SizedBox,
} from 'src/components';
import { DatePicker } from 'src/components/layout/DatePicker';
import { Navigation } from 'src/navigations/RootNavigation';
import { AppColors } from 'src/themes/Colors';
import { fontSizes, metrics, pixelScaler } from 'src/themes/Metrics';
import * as Yup from 'yup';

import { Divider } from '@mui/material';
import moment from 'moment';
import { IconSvg } from 'src/assets';
import { TripParamsProps } from 'src/common/api/request';
// import { useSocketSeatSelectedMutation } from 'src/common/hooks/socket/useSocketSelectSeatMutation';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { NewButtonInput } from 'src/components/bases/NewButtonInput';
import { OriginDestinationCard } from './OriginDestinationCard';

export const TravelPanel = ({ onFocus, onBlur }: { onFocus: () => void; onBlur: () => void }) => {
  // const { t } = useTranslation();
  // const { data, isLoading } = useServiceQuery();
  // const searchBusMutation = useSearchBusMutation();

  // const [tabIndex, setTabIndex] = React.useState<number>(0);
  // const [provinceVisible, setProvinceVisible] = React.useState<string | null>();
  // const [from, setFrom] = React.useState<LocationProps>();
  // const [to, setTo] = React.useState<LocationProps>();

  // const { mutate } = useSocketSeatSelectedMutation('seat_already_selected_channel');
  const { setSearchInfo } = useTripInfoState();
  const [dateVisible, setDateVisible] = React.useState<string | null>(null);
  // const [passengerModalVisible, setPassengerModalVisible] = React.useState<boolean>(false);
  // const [passenger, setPassenger] = React.useState<number>(0);

  const TravalScema = Yup.object().shape({
    fromLocation: Yup.object()
      .shape({
        abbreviation: Yup.string().required('Required'),
        id: Yup.string().required('Required'),
        name: Yup.string().required('Required'),
        slug: Yup.string().required('Required'),
      })
      .nullable()
      .required('Required'),
    toLocation: Yup.object()
      .shape({
        abbreviation: Yup.string().required('Required'),
        id: Yup.string().required('Required'),
        name: Yup.string().required('Required'),
        slug: Yup.string().required('Required'),
      })
      .nullable()
      .required('Required'),
  });

  const {
    control,
    handleSubmit,
    clearErrors,
    // setError,
    // formState: { errors },
  } = useForm<TripParamsProps>({
    defaultValues: isDummy
      ? {
          fromLocation: {
            abbreviation: 'pp',
            id: '1XSE',
            name: 'Phnom Penh',
            slug: 'phnom_penh',
          },
          toLocation: {
            abbreviation: 'sr',
            id: '1XSEsadas',
            name: 'Siem Reap',
            slug: 'siem_reap',
          },
          departureDate: new Date(),
          returnDate: null,
          passenger: 1,
          serviceSlug: 'bus',
        }
      : {
          departureDate: new Date(),
          returnDate: null,
          passenger: 0,
          serviceSlug: 'bus',
          fromLocation: undefined,
          toLocation: undefined,
        },
    mode: 'onSubmit',
    resolver: yupResolver(TravalScema),
  });

  const departureDateController = useController({ control, name: 'departureDate' });
  const returnDateController = useController({ control, name: 'returnDate' });
  const passengerController = useController({ control, name: 'passenger' });

  // if (isLoading) <ActivityIndicator />;

  const handleDateDismiss = () => {
    setDateVisible(null);
  };

  const handleDeparturePressed = () => setDateVisible('departure');

  const handleTripReturnPressed = () => setDateVisible('return');

  const handleDatePickedConfirm = (selectedDate: Date) => {
    handleDateDismiss();

    if (dateVisible === 'departure') {
      departureDateController.field.onChange(selectedDate);
    } else {
      returnDateController.field.onChange(selectedDate);
    }
  };

  // const handleClosePassenderModel = () => setPassengerModalVisible(false);

  const handleSubmitPress = (data: TripParamsProps) => {
    console.log(data);
    clearErrors();
    setSearchInfo(data);
    Navigation.navigate('TripListScreen');
  };

  return (
    <>
      <Container padding={metrics.large} paddingTop={0}>
        <OriginDestinationCard control={control} onFocus={onFocus} onBlur={onBlur} />

        <CardContainer style={{ zIndex: 1 }} padding={0} marginTop={pixelScaler(8)}>
          <Row paddingVertical={metrics.medium} paddingHorizontal={metrics.large} width="100%" middle>
            <NewButtonInput
              row
              labelLang="departureDate"
              placeholderLang="departureDate"
              onPress={handleDeparturePressed}
              value={
                departureDateController.field.value === null ? '' : formatDate(departureDateController.field.value)
              }
              onChange={departureDateController.field.onChange}
              clearValue={null}
              iconLeft={<IconSvg.Calender fill={AppColors.lighterGray} />}
            />

            <NewButtonInput
              row
              clearButton
              labelLang="returnDate"
              placeholderLang="returnDate"
              onPress={handleTripReturnPressed}
              value={returnDateController.field.value === null ? '' : formatDate(returnDateController.field.value)}
              onChange={returnDateController.field.onChange}
              clearValue={null}
              iconLeft={<IconSvg.Calender fill={AppColors.lighterGray} />}
            />
          </Row>
          <Divider />
          <Container marginLeft={metrics.tiny} paddingHorizontal={metrics.large} paddingVertical={metrics.medium}>
            <Row height={metrics.inputHeight} width="100%" middle>
              <IconSvg.Passenger />
              <SizedBox />
              <RegularText fontSize="large" color={AppColors.gray} textLang="passenger" />
              <Row flex />
              <Row center>
                {passengerController.field.value > 0 && (
                  <>
                    <IconButton
                      style={styles.circleButton}
                      icon={<AntDesign name="minus" size={fontSizes.large} />}
                      onPress={() => {
                        passengerController.field.onChange(passengerController.field.value - 1);
                      }}
                    />
                    <Row width={pixelScaler(50)} center>
                      <RegularText fontSize="large">{passengerController.field.value}</RegularText>
                    </Row>
                  </>
                )}
                <IconButton
                  style={styles.circleButton}
                  icon={<AntDesign name="plus" size={fontSizes.large} />}
                  onPress={() => {
                    passengerController.field.onChange(passengerController.field.value + 1);
                  }}
                />
              </Row>
            </Row>
          </Container>
        </CardContainer>
        <SizedBox />
        <PrimaryButton
          text="search"
          onPress={() => {
            handleSubmit(handleSubmitPress)();

            // mutate('hi11');
          }}
        />
      </Container>
      <DatePicker
        value={departureDateController.field.value}
        onConfirm={handleDatePickedConfirm}
        onClose={handleDateDismiss}
        isVisible={!isEmpty(dateVisible)}
        disabledDates={date => {
          if (
            date.isBefore(
              dateVisible === 'departure'
                ? moment().format('DD MMM, YYYY')
                : moment(departureDateController.field.value).format('DD MMM, YYYY'),
            )
          )
            return true;
          return false;
        }}
      />

      {/* <PassengerModal
        value={passenger}
        onClose={handleClosePassenderModel}
        isVisible={passengerModalVisible}
        onDonePressed={setPassenger}
      /> */}
    </>
  );
};

const styles = StyleSheet.create({
  circleButton: {
    borderRadius: 20,
    width: pixelScaler(28),
    height: pixelScaler(28),
    borderWidth: 1,
    borderColor: AppColors.border,
    alignSelf: 'center',
    justifyContent: 'center',
  },
});
